import React from "react";
import {useMutation, useQuery} from "@apollo/client";
import {DeleteButton, EditButton} from "../../../helpers/ButtonHelper";
import {deletePlateMutation, getPlates} from "./ReportQueries";
import {deleteItem, tableImageTag} from "../../../helpers/Api";

const ReportsList = () => {
  return "No Reports"
  const { data } = useQuery(getPlates, { fetchPolicy: "no-cache" })
  const [deleteCall] = useMutation(deletePlateMutation, { refetchQueries: [getPlates] })

  const header = <tr>
    <th>Denumire</th>
    <th>Perioada zilei</th>
    <th>#Ingrediente</th>
    <th className='actions'></th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>
        {tableImageTag(item)}
        {item.name}
      </td>
      <td>{item.category.name}</td>
      <td>{item.ingredientsCount}</td>
      <td className='actions'>
        <EditButton to={`/plates/${item.id}`} />
        <DeleteButton onClick={e => deleteItem(e, item.id, deleteCall)} />
      </td>
    </tr>
  }

  // return (
  //   <div className="container">
  //     <PageTitle title='Retetele mele' buttons={<AddButton to='/plates/new'/>}/>
  //     <div className="row justify-content-md-center">
  //       <div className="page-container col">
  //         <ListTable data={data && data.plates} header={header} listItem={listItem}
  //                    searchFields={['name', 'category.name']}/>
  //       </div>
  //     </div>
  //   </div>
  // )
};

export default ReportsList;
